/**
 * MultiDragOverlay Component
 * 
 * Displays a compact visual preview during multi-select drag operations.
 * Shows only the count of songs being moved.
 */

import React from 'react';

interface MultiDragOverlayProps {
  songs: any[];
  count: number;
}

const MultiDragOverlay: React.FC<MultiDragOverlayProps> = ({ count }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#111823',
        border: '2px solid #4a90d9',
        borderRadius: '8px',
        padding: '12px 24px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
        height: '50px',
        boxSizing: 'border-box',
      }}
    >
      <span
        style={{
          color: 'white',
          fontSize: '14px',
          fontWeight: 600,
        }}
      >
        Moving {count} songs
      </span>
    </div>
  );
};

export default MultiDragOverlay;
